import type { Transition, Variants } from 'framer-motion';

/**
 * Standard motion for the on-demand collect wizard — used for step transitions
 * (WizardLayout), the pre-selection results area, and selectable list items.
 * Keep this the single source so the whole flow feels consistent.
 */
export const STEP_ENTER_TRANSITION: Transition = { duration: 0.25, ease: 'easeOut' };
export const STEP_EXIT_TRANSITION: Transition = { duration: 0.15, ease: 'easeIn' };

/** Full step content (WizardLayout children) — fade + small vertical slide. */
export const stepVariants: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: STEP_ENTER_TRANSITION },
  exit: { opacity: 0, y: -8, transition: STEP_EXIT_TRANSITION },
};

/** Smaller content blocks that swap in place (results list, filter changes) — plain fade. */
export const listVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.2, ease: 'easeOut' } },
  exit: { opacity: 0, transition: { duration: 0.12, ease: 'easeIn' } },
};

/** Tap/hover feedback for selectable cards. */
export const SELECTABLE_TAP = { scale: 0.97 };
export const SELECTABLE_HOVER = { scale: 1.01 };
export const SELECTABLE_TRANSITION: Transition = { duration: 0.15, ease: 'easeOut' };
